import Axios from 'axios';
import Serve from '../app/serve';

async function getPerfis() {
  const token = localStorage.getItem('token');
  const app = Serve();
  let perfis = [];

  await Axios.get(app + 'listar_perfis', {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then(res => {
    if (res !== undefined) {
      if (res.data.status && (res.data.status === 498 || res.data.status === 401)) {
        //localStorage.clear();
      } else {
        console.log('listar_perfis', res);
        perfis = res.data.data;

      }
    }
  })

  return perfis;
};

export default getPerfis;